'use strict';

var React = require('react');

var SvgSimplifyMinor = function SvgSimplifyMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.25a.75.75 0 0 0 0-1.5h-4.69l1.22-1.22a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.75a.75.75 0 0 0 0 1.5h4.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 1.06l1.22 1.22h-4.69Z"
  }));
};
SvgSimplifyMinor.displayName = "SimplifyMinor";

exports.SvgSimplifyMinor = SvgSimplifyMinor;
